export const GET_COMPANY_DASHBOARD_STATS = "GET_COMPANY_DASHBOARD_STATS"
export const GET_COMPANY_DASHBOARD_STATS_SUCCESS = "GET_COMPANY_DASHBOARD_STATS_SUCCESS"
export const GET_COMPANY_DASHBOARD_STATS_FAIL = "GET_COMPANY_DASHBOARD_STATS_FAIL"
